// App.js
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

import Dashboard from './components/Dashboard';
import JobApplications from './components/JobApplications';
import BIMProject from './components/BIMProject';
import News from './components/News';
import AboutUs from './components/AboutUs';
import Project from './components/Project';
import AddProject from './components/AddProject';
import ProjectDetails from './components/ProjectDetails';
import HomePageAdmin from './components/HomePageAdmin';
import ApplicantDetails from './components/ApplicantDetails';
import NewsDetails from './components/NewsDetails';
import FuturisticAdmin from './components/FuturisticAdmin'; // ✅ ADD THIS
import Login from './components/Login';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/login" element={user ? <Navigate to="/login" /> : <Login />} />

        <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/job-applications" element={user ? <JobApplications /> : <Navigate to="/login" />} />
        <Route path="/bim-project" element={user ? <BIMProject /> : <Navigate to="/login" />} />
        <Route path="/news" element={user ? <News /> : <Navigate to="/login" />} />
        <Route path="/news/:newsId" element={user ? <NewsDetails /> : <Navigate to="/login" />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/homepage" element={<HomePageAdmin />} />

        {/* Projects */}
        <Route path="/project" element={user ? <Project /> : <Navigate to="/login" />} />

        <Route
          path="/projects/new"
          element={user ? <AddProject /> : <Navigate to="/login" />}
        />

        <Route
          path="/project/:projectId"
          element={user ? <ProjectDetails /> : <Navigate to="/login" />}
        />

        {/* Futuristic Projects Admin */}
        <Route
          path="/futuristic-admin"
          element={user ? <FuturisticAdmin /> : <Navigate to="/login" />}
        />

        <Route
          path="/applicant/:id"
          element={user ? <ApplicantDetails /> : <Navigate to="/login" />}
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;